export const UserRequireModel = [
  {
    customerType: '1',
    fieldRequired: [
      'taxNumber',
      'companyName',
      'addressName',
      'aliasName',
      'staffCode'
      // 'customerSegment',
    ],
  },
  {
    customerType: '2',
    fieldRequired: [
      'identificationNumber',
      'name',
      'gender',
      'addressName',
      'birthday',
      'mobile',
      'email',
      // 'customerSegment',
    ],
  },
]
